import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { firstValueFrom } from 'rxjs'
import { NaturalStoneLot } from '../interfaces/natural-stone/natural-stone-lots'
import { NaturalStoneService } from './natural-stone.service'
import { NaturalStoneColor } from '../interfaces/natural-stone/natural-stone-color'
import { DecimalPipe } from '@angular/common'


@Injectable({
    providedIn: 'root',
})
export class NaturalStoneColorService {

    constructor(private translate: TranslateService, private naturalStoneService: NaturalStoneService) {
    }

    getBrandText(color: NaturalStoneColor) {
        return this.naturalStoneService.getBrandText(color)
    }

    getColorText(color: NaturalStoneColor) {
        return this.naturalStoneService.getColorText(color)
    }

    getThickness(thickness: string) {
        return parseFloat(thickness)
    }

    getThicknessText(thickness: string, decimalPipe: DecimalPipe) {
        const thicknessNumber = this.getThickness(thickness)
        return thicknessNumber ? decimalPipe.transform(thicknessNumber, '1.0-1') + ' cm' : ''
    }

    async getFinish(finish: string) {
        let finishLabel: string | undefined = await firstValueFrom(this.translate.get('finishes.' + finish))
        if(!finishLabel || finishLabel.includes('finishes.')){
            return finish;
        }
        return finishLabel;
    }

    getWidth(lot: NaturalStoneLot) {
        return this.naturalStoneService.isUsa ? lot.widthUsa : lot.widthEur
    }

    getHeight(lot: NaturalStoneLot) {
        return this.naturalStoneService.isUsa ? lot.heightUsa : lot.heightEur
    }

    getMeasureUnit() {
        return this.naturalStoneService.isUsa ? ' ft' : ' cm'
    }

    getMeasurementsText(lot: NaturalStoneLot, decimalPipe: DecimalPipe){
        const widthFormatted = decimalPipe.transform(this.getWidth(lot), '1.0-2')
        const heightFormatted = decimalPipe.transform(this.getHeight(lot), '1.0-2')
        return widthFormatted && heightFormatted ? `${widthFormatted} x ${heightFormatted}${this.getMeasureUnit()}` : ''
    }

    getSurfaceArea(lot: NaturalStoneLot) {
        return this.naturalStoneService.isUsa ? (lot.surfaceAreaUsa || 0) : (lot.surfaceAreaEur || 0)
    }

    getSurfaceAreaMeasure() {
        return this.naturalStoneService.isUsa ? ' SqFt' : ' m²'
    }

    getSurfaceAreaText(lot: NaturalStoneLot, decimalPipe: DecimalPipe, qty?: number){
        const surfaceAreaNumber = this.getSurfaceArea(lot)
        const surfaceAreaMeasureUnit = this.getSurfaceAreaMeasure()

        const surfaceAreaPerSlabFormatted = decimalPipe.transform(qty ? (surfaceAreaNumber * qty) : surfaceAreaNumber, '1.0-2')
        return surfaceAreaPerSlabFormatted ? surfaceAreaPerSlabFormatted + surfaceAreaMeasureUnit : ''
    }

    getAvailableSlabs(lot: NaturalStoneLot): number {
        return this.naturalStoneService.getAvailableSlabsForLotAndBundle(lot.lotId!, lot.bundleId)
    }

}
